// Web implementation of notifications - Firebase Cloud Messaging for web
// Note: Web push notifications require service worker setup and VAPID keys
// For now, we provide no-op implementations as web notifications aren't critical

export interface NotificationPermissionResult {
  granted: boolean;
  token?: string;
  error?: string;
}

/**
 * Request notification permissions (Web)
 * Web notifications require service worker and user permission
 */
export const requestNotificationPermission = async (): Promise<NotificationPermissionResult> => {
  console.log('Web: Notification permissions not implemented yet');
  return {
    granted: false,
    error: 'Web push notifications not implemented',
  };
};

/**
 * Get current FCM token (Web stub)
 */
export const getFCMToken = async (): Promise<string | null> => {
  console.log('Web: FCM token not available');
  return null;
};

/**
 * Delete FCM token (Web stub)
 */
export const deleteFCMToken = async (): Promise<void> => {
  console.log('Web: FCM token deletion not needed');
};

/**
 * Subscribe to a topic (Web stub)
 */
export const subscribeToTopic = async (topic: string): Promise<void> => {
  console.log(`Web: Topic subscription not implemented: ${topic}`);
};

/**
 * Unsubscribe from a topic (Web stub)
 */
export const unsubscribeFromTopic = async (topic: string): Promise<void> => {
  console.log(`Web: Topic unsubscription not implemented: ${topic}`);
};

/**
 * Handle foreground notifications (Web stub)
 */
export const onForegroundNotification = (
  callback: (message: any) => void
) => {
  console.log('Web: Foreground notifications not implemented');
  return () => {}; // Return no-op unsubscribe
};

/**
 * Handle background notification open (Web stub)
 */
export const onBackgroundNotificationOpen = (
  callback: (message: any) => void
) => {
  console.log('Web: Background notifications not implemented');
  return () => {}; // Return no-op unsubscribe
};

/**
 * Get initial notification (Web stub)
 */
export const getInitialNotification = async (): Promise<any | null> => {
  console.log('Web: Initial notification not implemented');
  return null;
};

/**
 * Set background message handler (Web stub)
 */
export const setBackgroundMessageHandler = (
  handler: (message: any) => Promise<void>
) => {
  console.log('Web: Background message handler not implemented');
};

/**
 * Check if notification permission is granted (Web)
 */
export const checkNotificationPermission = async (): Promise<boolean> => {
  if ('Notification' in window) {
    return Notification.permission === 'granted';
  }
  return false;
};

/**
 * Listen to token refresh (Web stub)
 */
export const onTokenRefresh = (callback: (token: string) => void) => {
  console.log('Web: Token refresh listener not implemented');
  return () => {}; // Return no-op unsubscribe
};
